import { InjectionToken } from '@angular/core';
export const VERSION_INFO = new InjectionToken<string>('VERSION_INFO');
